/* src/app/components/support/support.component.css */
.fa-special-position {
  margin: 0px 15px 20px;
  font-size: 3.0em;
  color: #0071bb;
}
/*# sourceMappingURL=support.component.css.map */
